module.exports = __webpack_public_path__ + "img/mail.ecde9824.png";